export default __webpack_public_path__ + "static/media/char_body_prem_012.a0dea3d5.png";